import React from "react";
import {
  ComponentType,
  lazy,
  LazyExoticComponent,
  useEffect,
  useState,
} from "react";

// @ts-ignore
export const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    if (typeof window === "undefined" || !window.localStorage) {
      return componentImport();
    }

    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem("page-has-been-force-refreshed") || "false"
    );

    try {
      const component = await componentImport();

      window.localStorage.setItem("page-has-been-force-refreshed", "false");

      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        window.localStorage.setItem("page-has-been-force-refreshed", "true");
        return window.location.reload();
      }

      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  });

export function useLazyWithoutRetry(importFunc: () => void) {
  const [component, setComponent] =
    useState<LazyExoticComponent<ComponentType<any>>>();

  useEffect(() => {
    const component = lazyWithRetry(importFunc);
    setComponent(component);
    // only lazy once after the component is rendered
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (component) {
    return component;
  }
  return () => <></>;
}
